import React from 'react';

import AlertBody from './AlertBody';
import Dismissable from './Dismissable';
import Persistent from './Persistent';

type Props = {
  email: string;
  integrationId: number;
  persistId?: string;
};

export default function PartnerSandboxAlert({
  email,
  integrationId,
  persistId,
}: Props) {
  return persistId ? (
    <Dismissable persistId={persistId}>
      <AlertBody email={email} integrationId={integrationId} />
    </Dismissable>
  ) : (
    <Persistent>
      <AlertBody email={email} integrationId={integrationId} />
    </Persistent>
  );
}
